import { PAX_TYPE } from 'app/typings/core/admin/enum/paxType';
import { AVAILABILITY_MODE } from 'app/typings/core/admin/experiences/enum/availabilityMode';
import { EXPERIENCE_STATUS } from 'app/typings/core/admin/experiences/enum/experienceStatus';
import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import { PRICE_DIFFERENTIATION_MODE } from 'app/typings/core/common/openingConfiguration/priceConfigurationType';

export const DEFAULT_EXPERIENCE_DATA: ExperienceResponse = {
  id: 0,
  categoryId: 0,
  status: EXPERIENCE_STATUS.UNPUBLISHED,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  spaceIds: [],
  description: undefined,
  hotelId: undefined,
  countryId: undefined,
  coverPictureId: undefined,
  emojiId: undefined,
  openingHours: undefined,
  brand: undefined,
  duration: undefined,
  durationDescription: undefined,
  time: undefined,
  isRoomServiceAvailable: false,
  isRoomServiceIncluded: false,
  roomServicePrice: undefined,
  accessMode: undefined,
  location: undefined,
  closingPeriods: [],
  closedDaysBeforeCheckIn: undefined,
  maxQuantity: undefined,
  availableDayLimits: undefined,
  tagline: undefined,
  minPax: undefined,
  maxPax: undefined,
  isAlwaysIncludedWithNight: false,
  allowedPaxTypes: [PAX_TYPE.ADULT, PAX_TYPE.CHILD],
  deletedAt: undefined,
  coverPicture: undefined,
  emoji: undefined,
  experiencePictures: [],
  openingConfiguration: {
    stockConfiguration: {
      type: OPENING_CONFIGURATION_TYPE.CONSTANT,
      configuration: { stock: null },
    },
    priceConfiguration: {
      type: OPENING_CONFIGURATION_TYPE.CONSTANT,
      priceDifferentiationMode: PRICE_DIFFERENTIATION_MODE.NONE,
      configuration: {},
    },
  },
  showInInventory: true,
  availabilityMode: AVAILABILITY_MODE.DAILY,
  isInPublishedPack: false,
  isTimeslotDaytimeOnly: null,
};
